import { render, staticRenderFns } from "./S3.vue?vue&type=template&id=156dc690&scoped=true&"
import script from "./S3.vue?vue&type=script&lang=js&"
export * from "./S3.vue?vue&type=script&lang=js&"
import style0 from "./S3.vue?vue&type=style&index=0&id=156dc690&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156dc690",
  null
  
)

export default component.exports